// Product Slider v1.0.0

class ProductSlider {
  constructor() {
    this.init();
  }

  init() {
    // Le slider utilise le système zag-slider existant
    // Aucune logique JavaScript spécifique n'est nécessaire
    // car la section hérite du comportement de featured-collection
  }
}

// Initialisation
document.addEventListener("DOMContentLoaded", () => {
  new ProductSlider();
});
